import React from 'react'

interface ExcellentIconProps {
  width?: number
  height?: number
}

const ExcellentIcon: React.FC<ExcellentIconProps> = ({ width = 84, height = 44 }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 84 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="path-1-outside-1_3565_11750"
        maskUnits="userSpaceOnUse"
        x="0"
        y="-0.0322266"
        width="84"
        height="44"
        fill="black"
      >
        <rect fill="white" y="-0.0322266" width="84" height="44" />
        <path d="M82 41.9678C82 31.3677 77.7856 21.2015 70.2842 13.7061C62.7827 6.21076 52.6086 2 42 2C31.3914 2 21.2173 6.21077 13.7158 13.7061C6.21437 21.2015 2 31.3677 2 41.9678H18C18 28.7236 28.7452 17.9873 42 17.9873C55.0477 17.9873 65.6635 28.3906 65.9922 41.3486L66 41.9678H82Z" />
      </mask>
      <path
        d="M82 41.9678C82 31.3677 77.7856 21.2015 70.2842 13.7061C62.7827 6.21076 52.6086 2 42 2C31.3914 2 21.2173 6.21077 13.7158 13.7061C6.21437 21.2015 2 31.3677 2 41.9678H18C18 28.7236 28.7452 17.9873 42 17.9873C55.0477 17.9873 65.6635 28.3906 65.9922 41.3486L66 41.9678H82Z"
        fill="#4F8D73"
      />
      <path
        d="M82 41.9678H84V43.9678H82V41.9678ZM70.2842 13.7061L71.6978 12.2913L71.6978 12.2913L70.2842 13.7061ZM42 2V0V2ZM13.7158 13.7061L12.3022 12.2913L12.3022 12.2913L13.7158 13.7061ZM2 41.9678V43.9678H-2.38419e-07L0 41.9678L2 41.9678ZM18 41.9678H20V43.9678H18V41.9678ZM42 17.9873V15.9873V17.9873ZM65.9922 41.3486L67.9915 41.2979L67.9919 41.3107L67.992 41.3234L65.9922 41.3486ZM66 41.9678V43.9678H64.0251L64.0002 41.993L66 41.9678ZM82 41.9678H80C80 31.8986 75.9967 22.2413 68.8705 15.1208L70.2842 13.7061L71.6978 12.2913C79.5745 20.1616 84 30.8367 84 41.9678H82ZM70.2842 13.7061L68.8705 15.1208C61.7443 8.00045 52.0787 4 42 4V2V0C53.1385 3.8147e-06 63.8212 4.42107 71.6978 12.2913L70.2842 13.7061ZM42 2V4C31.9213 4 22.2557 8.00046 15.1295 15.1208L13.7158 13.7061L12.3022 12.2913C20.1788 4.42108 30.8615 0 42 0V2ZM13.7158 13.7061L15.1295 15.1208C8.00326 22.2413 4 31.8986 4 41.9678L2 41.9678L0 41.9678C1.66893e-06 30.8367 4.42547 20.1616 12.3022 12.2913L13.7158 13.7061ZM2 41.9678V39.9678H18V41.9678V43.9678H2V41.9678ZM18 41.9678H16C16 27.6175 27.6421 15.9873 42 15.9873V17.9873V19.9873C29.8482 19.9873 20 29.8297 20 41.9678H18ZM42 17.9873V15.9873C56.1338 15.9873 67.6354 27.2567 67.9915 41.2979L65.9922 41.3486L63.9928 41.3993C63.6916 29.5245 53.9616 19.9873 42 19.9873V17.9873ZM65.9922 41.3486L67.992 41.3234L67.9998 41.9425L66 41.9678L64.0002 41.993L63.9923 41.3739L65.9922 41.3486ZM66 41.9678V39.9678H82V41.9678V43.9678H66V41.9678Z"
        fill="white"
        mask="url(#path-1-outside-1_3565_11750)"
      />
      <path
        d="M18 41.959C18.0047 28.7189 28.7481 17.9873 42 17.9873C49.9824 17.9874 57.0528 21.8825 61.416 27.873L74.3604 18.4756C69.396 11.6483 62.3965 6.56562 54.3643 3.95703C46.332 1.34847 37.6795 1.34785 29.6465 3.9541C21.6135 6.56038 14.6118 11.6399 9.64551 18.4658C4.67929 25.2916 2.0033 33.5132 2 41.9521L18 41.959Z"
        fill="#4F8D73"
      />
      <path
        d="M18 41.9873C18 41.9808 18 41.9743 18 41.9678C18 28.7236 28.7452 17.9873 42 17.9873C44.5888 17.9873 47.081 18.3994 49.417 19.1572L54.3604 3.95605C48.3544 2.00618 41.9715 1.50481 35.7344 2.49316C29.4973 3.48151 23.5831 5.93167 18.4756 9.64258C13.368 13.3536 9.21226 18.2207 6.34865 23.8447C3.48512 29.4687 1.99493 35.6901 2.00001 42L18 41.9873Z"
        fill="#4F8D73"
      />
      <path
        d="M18 41.9619C18.0025 31.3076 24.9592 22.2793 34.5811 19.1572L29.6387 3.95605C21.6069 6.56368 14.6075 11.6447 9.64258 18.4707C4.67762 25.2969 2.0023 33.5185 2 41.957L18 41.9619Z"
        fill="#4F8D73"
      />
    </svg>
  )
}

export default ExcellentIcon
